import React from 'react';
import DeleteBtn from 'components/Custom/DeleteBtn';
import EditBtn from 'components/Custom/EditBtn';


const withEditFunctions = (WrappedComponent, { role, formPath, deleteRecord, canUpdate=true, canDelete=true, selectedProject, component }) => {
  return class WithEditFunctions extends React.Component {
    tableRef = React.createRef();
    constructor(props) {
      super(props);
      this.state = {
        updateDate: new Date(),
        editable: role.check(component, 'delete') && canDelete && DeleteBtn(() => {this.setState({updateDate: new Date()})}, deleteRecord, selectedProject),
        detailsPanel: role.check(component, 'update') && canUpdate && EditBtn(() => this.setState({updateDate: new Date()}), formPath)
      };
      if (props.tableRef) {
        this.tableRef = props.tableRef;
      };
    };

    render() {
      const extendProps = {
        ...this.state.detailsPanel && { detailPanel: this.state.detailsPanel },
        ...this.state.editable && { editable: this.state.editable }
      }

      return (
        <>
          <WrappedComponent key={this.state.updateDate} tableRef={this.tableRef} {...this.props} {...extendProps} />
        </>
      )
    }
  }
}

export default withEditFunctions;